;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';

import cx from 'clsx';

import Img from 'components/ui/Img';
import Text from 'components/ui/Text';

import styles from './TalesBlockImageFull.module.scss';

const TalesBlockImageFull = ({
    image,
    border = true,
    isActive,
    inViewDelay,
}) => {
    const rootRef = useRef(null);
    const [isInView, setIsInView] = useState(false);

    const intersection = useIntersection(rootRef, {
        root: null,
        rootMargin: '0px',
        threshold: 0.4,
    });

    useEffect(() => {
        if (intersection?.isIntersecting && isActive) {
            setIsInView(true);
        }

        if (!isActive) {
            setIsInView(false);
        }
    }, [intersection, isActive]);

    return (
        <section
            ref={rootRef}
            className={cx(styles.root, {
                [styles.border]: border,
                [styles.isInView]: isInView,
            })}
            style={{
                '--in-view-delay': inViewDelay ? `${inViewDelay}s` : '0.1s',
            }}
        >
            <div className={styles.inner}>
                <div className={styles.media}>
                    <Img
                        className={styles.image}
                        src={image.url}
                        width={image?.width}
                        height={image?.height}
                        alt={image.description}
                        customSources={[
                            {
                                breakpoint: 768,
                                src: image.url,
                                imageWidth: 1920,
                            },
                            {
                                src: image.url,
                                imageWidth: 1280,
                            },
                        ]}
                    />
                    {image.description && (
                        <Text baseTheme="bodyXSmall" className={styles.caption}>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: image.description,
                                }}
                            />
                        </Text>
                    )}
                </div>
            </div>
        </section>
    );
};

export default TalesBlockImageFull;
